/* eslint-disable eslint-comments/disable-enable-pair --- for below comment */
/* eslint-disable react/destructuring-assignment -- disable destructuring-assignment */
/**
 * Component: ErrorMessage
 * Displays 404 & 500 error messages
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '@americanexpress/one-app-router';
import { clearError } from '@americanexpress/one-app-ducks';
import { FormattedMessage } from 'react-intl';
import { Link, ButtonBase, ProgressCircular } from '@americanexpress/dls-react';

class ErrorMessage extends Component {
  constructor(props) {
    super(props);
    this.onGoBack = this.onGoBack.bind(this);
  }

  onGoBack() {
    this.props.clearError();
    this.props.router.goBack();
  }

  render() {
    const {
      code,
      hideBackLink,
      hideLinks,
      header,
      message,
      leftLink,
      rightLink,
    } = this.props;
    let body;
    let links;

    if (code) {
      links = (
        <React.Fragment>
          <hr className="alert-separator" />
          <ul className="list-links-inline-separator">
            {!hideBackLink && (
              <li>
                {leftLink || (
                  <ButtonBase onClick={this.onGoBack} className="color-text-link bg-none">
                    <FormattedMessage id="previousPage" />
                  </ButtonBase>
                )}
              </li>
            )}
            <li>
              {rightLink || (
                <Link href="/">
                  <FormattedMessage id="homePage" />
                </Link>
              )}
            </li>
          </ul>
        </React.Fragment>
      );

      body = (
        <div id="manage_booking_root_error_message">
          <span className="icon dls-icon-warning-filled dls-red" />
          <div>
            <h4 className="dlsStyles.dls-gray-05 dlsStyles.heading-4 margin-1-tb">
              {header || <FormattedMessage id={`${code}_heading`} />}
            </h4>
            <p className="body-3">
              {message || <FormattedMessage id={`${code}_message`} />}
            </p>
          </div>
          {!hideLinks && links}
        </div>
      );
    } else {
      body = (
        <ProgressCircular
          labelOverrides={{
            screenReaderLabel: 'Root Error Progress Bar',
          }}
        />
      );
    }

    return (
      <div className="module">
        <div className="alert-warn alert-dialog" role="alert">
          {body}
        </div>
      </div>
    );
  }
}

ErrorMessage.propTypes = {
  code: PropTypes.oneOf(['404', '500']).isRequired,
  router: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  clearError: PropTypes.func.isRequired,
  hideBackLink: PropTypes.bool,
  hideLinks: PropTypes.bool,
  header: PropTypes.node,
  message: PropTypes.node,
  leftLink: PropTypes.node,
  rightLink: PropTypes.node,
};

ErrorMessage.defaultProps = {
  hideBackLink: false,
  hideLinks: false,
  header: null,
  message: null,
  leftLink: null,
  rightLink: null,
};

export function mapStateToProps(state, ownProps) {
  return {
    code: ownProps.code || state.getIn(['error', 'code']),
  };
}

const hocChain = compose(connect(mapStateToProps, { clearError }), withRouter);

export { ErrorMessage as TestableErrorMessage };

export default hocChain(ErrorMessage);
